<template>
  <div v-if="company">
    <v-alert
      v-if="company.versteckt == 1"
      v-model="alert"
      type="warning"
      style="width: 40%;"
    >Dieser Betrieb ist im Moment versteckt und wird nicht über die Suche gefunden.</v-alert>

    <profil-premium 
      v-if="company.premium" 
      :company="company"
    ></profil-premium>

    <profil-standard 
      v-else 
      :company="company"
    ></profil-standard>

  </div>
</template>

<script>
import ProfilStandard from '~/components/companies/standard'
import ProfilPremium from '~/components/companies/premium'

import ListingSave from '~/components/ListingSave.vue'
import FehlerMelden from '~/components/FehlerMelden.vue'

import NachrichtErstellen from '~/components/nachrichten/NachrichtErstellen.vue'

import axios from 'axios'

export default {
  data () {
    return {
      post: null,
      error: null,
      companyId: null,
      alert: true,
      leistung: null,
      company: {
        name: '',
        address: '',
        website: '',
        image_logo: '',

        email: '',
        leistung: '',
        innung: {
          logo: '',
          name: ''
        }
      },

      nachricht: {
        name: '',
        address: '',
        website: '',
        email: ''
      },
      dialog1: false,
      dialog2: false,
      BetriebsTitle: 'LokalesHandwerk Betrieb'
    }
  },
  beforeRouteEnter (to, from, next) {
    // const app = this

    axios
      .get('/api/v1/companies/' + to.params.id)
      .then(resp => {
        next(vm => (vm.company = resp.data))
      })
      .catch(error => {
        console.log('betrieb nicht gefunden:')
        console.log(error)
        next('/404')
      })
  },
  beforeRouteUpdate (to, from, next) {
    this.company = null
    axios
      .get('/api/v1/companies/' + to.params.id)
      .then(resp => {
        this.company = resp.data
        next()
      })
      .catch(error => {
        console.log('betrieb nicht gefunden:')
        console.log(error)
        next('/404')
      })
  },
  created () {
    // console.log('betrieb component erstellt');
  },

  // /////////////

  computed: {
    BetriebTitle: function () {
      if (this.company) {
        if (this.company.innungen) {
          return this.company.vollername
        } else {
          return this.company.vollername + ' in  der ' + this.company.innung.name
        }
      }
      // return this.company.name + ' in  der'
    }
  },

  metaInfo () {
    return { title: this.BetriebTitle }
  },

  components: {
    ProfilStandard,
    ProfilPremium,
    ListingSave,
    NachrichtErstellen,
    FehlerMelden
  },

  methods: {
    setData (err, post) {
      if (err) {
        this.error = err.toString()
      } else {
        this.post = post
      }
    }
  }
}
</script>

<style lang="stylus">
#carousel-view {
  .fade {
    &-enter-active, &-leave-active, &-leave-to {
      transition: 0.3s ease-out;
      position: absolute;
      top: 0;
      left: 0;
    }

    &-enter, &-leave, &-leave-to {
      opacity: 0;
    }
  }
}

.kontakt {
  padding: 0;
}
</style>